/* eslint-disable linebreak-style */
/* eslint-disable react/destructuring-assignment */
/* eslint-disable react/jsx-filename-extension */
import React, { useState, useEffect } from 'react';
import { Fade } from 'react-awesome-reveal';
import Header from 'parts/Header';
import Footer from 'parts/Footer';
import { DiscussForm } from 'parts/DiscussForm';

export const DiscussProjectPage = () => {
  const [data, setData] = useState({
    name: '',
    company: '',
    email: '',
    phone: '',
    projectIdea: '',
  });

  useEffect(() => {
    window.scroll(0, 0);
  }, []);

  const onChange = (event) => {
    setData((prevData) => ({
      ...prevData,
      [event.target.name]: event.target.value,
    }));
  };

  const resetForm = () => {
    setData({
      name: '',
      company: '',
      email: '',
      phone: '',
      projectIdea: '',
    });
  };

  return (
    <div className="bg-gradient-to-r from-[#1e1e2e] to-[#252541] min-h-screen text-white flex flex-col">
      <Header />

      <section className="container mx-auto px-6 py-16 flex flex-col items-center">
        <Fade triggerOnce direction="up">
          <h1 className="text-4xl md:text-6xl font-bold mb-6">Stel je vraag</h1>
        </Fade>

        <Fade triggerOnce direction="up" delay={200}>
          <div className="bg-white bg-opacity-10 rounded-lg p-8 shadow-lg w-full max-w-4xl">
            <DiscussForm data={data} onChange={onChange} resetForm={resetForm} />
          </div>
        </Fade>
      </section>

      <Footer />
    </div>
  );
};
